import React, { ReactNode, useCallback, useState } from 'react'
import tw from 'twin.macro'
import { ReactComponent as BackgroundImage } from 'src/assets/images/background.svg'
import PoweredLogoWhite from 'src/assets/images/poweredby-white.svg'
import LogoWhite from 'src/assets/images/gigsafe-logo-white.svg'
import { GetHelpModal } from 'src/components/settings/GetHelpModal'
import { Button } from 'src/components/shared/Button'
import { ChatMajor, QuestionMarkMajor } from '@shopify/polaris-icons'
import { show as showIntercom } from '@intercom/messenger-js-sdk'
import { useMediaQueries } from 'src/hooks/useMediaQueries'
import { getDriver } from 'src/selectors/driver'
import { useSelector } from 'react-redux'

interface Props {
  children: ReactNode
  childrenClassName?: any
}

export const ContractorPortalPublicWrapper = ({ children, childrenClassName }: Props) => {
  const { isDesktopOrTablet, isMobile } = useMediaQueries()

  const driver = useSelector(getDriver)

  const [isGetHelpOpen, setIsGetHelpOpen] = useState(false)

  const openGetHelp = useCallback(() => {
    setIsGetHelpOpen(true)
  }, [])

  const closeGetHelp = useCallback(() => {
    setIsGetHelpOpen(false)
  }, [])

  const handleGetHelpClick = useCallback(() => {
    if (driver) {
      showIntercom()

      return
    }

    openGetHelp()
  }, [driver, openGetHelp])

  return (
    <>
      <div css={tw`h-full w-full flex flex-col`}>
        <div
          css={tw`bg-primary-700 w-full h-16 p-4 shadow top-0 flex justify-between items-center fixed z-50`}
        >
          <img src={LogoWhite} css={tw`h-[28px]`} />
          <Button
            className={tw`w-[120px] px-3`}
            rightIcon={
              isMobile && <QuestionMarkMajor css={tw`fill-shades-0`} width={20} height={20} />
            }
            leftIcon={
              isDesktopOrTablet && <ChatMajor css={tw`fill-shades-0`} width={20} height={20} />
            }
            onClick={handleGetHelpClick}
            color={isDesktopOrTablet ? 'dark' : 'primary'}
            size="medium"
          >
            Get Help
          </Button>
        </div>
        <div
          css={tw`flex flex-1 bg-primary-800 items-center justify-center flex-col pb-4 lg:pb-6 pt-20 lg:pt-[112px]`}
        >
          <BackgroundImage css={tw`fixed top-0 bottom-0 z-0 h-full [&>path]:fill-primary-900`} />
          <div />
          <div css={tw`bg-shades-0  max-w-[390px] mx-4 rounded-2xl z-10 overflow-hidden`}>
            <div css={[tw`px-4 pt-6 pb-4`, childrenClassName]}>{children}</div>
          </div>
          <div css={tw`flex items-center mt-6 justify-center w-full`}>
            <img src={PoweredLogoWhite} />
          </div>
        </div>
      </div>
      <GetHelpModal isOpen={isGetHelpOpen} onClose={closeGetHelp} />
    </>
  )
}
